import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60715c4a&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=60715c4a&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=60715c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60715c4a",
  null
  
)

export default component.exports